import { Market } from "../../contracts";

export const filterOutrightsMarkets = (outrights: boolean, markets: Market[], outrightMarketIds: string[]) => {
    return markets.filter(
        (market: Market) => {
            return outrights
                    ? outrightMarketIds.indexOf(market.marketType.id) > -1
                    : outrightMarketIds.indexOf(market.marketType.id) < 0
        });
}